import axios from './axios';

const handleUploadProgressEvent = (progressEvent, onUploadProgress) => {
  const { loaded, total } = progressEvent;

  const percentProgress = (loaded / total) * 100;
  const sanitazedPercent = parseFloat(percentProgress.toFixed(2));

  onUploadProgress(sanitazedPercent);
};

const uploadImporterFile = async (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append('file', file);

  const axiosResponse = await axios.post(
    '/importer',
    formData,
    {
      onUploadProgress: (event) => handleUploadProgressEvent(event, onUploadProgress),
      timeout: 0,
    },
  );

  return axiosResponse;
};

const cancelProcessement = async () => axios.post('/importer/cancel');

const status = async () => {
  const axiosResponse = await axios.get('/importer');
  return axiosResponse.data;
};

const loadStatus = async () => {
  const axiosResponse = await axios.get('/load');
  return axiosResponse.data;
};

const loadGlobalFilters = async () => {
  const axiosResponse = await axios.get('/global-filter');
  return axiosResponse.data;
};

const saveGlobalFilters = async (data) => axios.post('/global-filter', data);

const loadSearchFilters = async () => {
  const axiosResponse = await axios.get('/search-filter');
  return axiosResponse.data;
};

const loadColumnsReference = async () => {
  const axiosResponse = await axios.get('/columns-reference');
  return axiosResponse.data;
};

const saveColumnsReference = async (data) => axios.post('/columns-reference', data);

const loadColumnsVehicle = async () => {
  const axiosResponse = await axios.get('/columns-vehicle');
  return axiosResponse.data;
};

const saveColumnsVehicle = async (data) => axios.post('/columns-vehicle', data);

const saveSearchFilters = async (data) => axios.post('/search-filter', data);

const publishStatus = async () => {
  const axiosResponse = await axios.get('/publish');
  return axiosResponse.data;
};

const publish = async () => axios.post('/publish');

const oneMinute = 1000 * 60;

const apiStatusSocket = (onConfigurationStatus, onProgressStatus, onPublishStatus) => {
  const webSocketUrl = process.env.REACT_APP_API_WEBSOCKET_URL;
  const socket = new WebSocket(`${webSocketUrl}/api/status`);

  socket.onmessage = ({ data }) => {
    if (data !== 'pong') {
      const sanitizedData = JSON.parse(data);

      const { type, content } = sanitizedData;

      if (type === 'PUBLISH_STATUS') {
        onPublishStatus(content);
      } else if (type === 'CONFIGURATION_STATUS') {
        onConfigurationStatus(content);
      } else if (type === 'IMPORTER_STATUS') {
        onProgressStatus(content);
      } else {
        /* TODO: william.guimaraes - ver lib para logs */
        /* eslint-disable no-console */
        console.error('services.api.index.onProcessingProgress.onError: ', type);
      }
    }
  };

  const pingMessage = () => {
    setTimeout(() => {
      if (socket.readyState === socket.OPEN) {
        socket.send('ping');
        pingMessage();
      }
    }, oneMinute);
  };

  socket.onopen = pingMessage;

  socket.onerror = (error) => {
    /* TODO: william.guimaraes - ver lib para logs */
    /* eslint-disable no-console */
    console.error('services.api.index.apiStatusSocket.onError: ', error);
    onProgressStatus({ status: 'ERROR', message: 'unexpected error' });
  };

  return () => socket.close();
};

export default {
  uploadImporterFile,
  cancelProcessement,
  apiStatusSocket,
  status,
  loadStatus,
  loadGlobalFilters,
  saveGlobalFilters,
  loadSearchFilters,
  saveSearchFilters,
  loadColumnsReference,
  saveColumnsReference,
  loadColumnsVehicle,
  saveColumnsVehicle,
  publishStatus,
  publish,
};
